import { Accordion } from "react-bootstrap";
import { ChevronDown } from "react-feather";
import SectionTable from "../SectionsTable";
import styles from "../../AddressBook.module.scss";

const AIFetchedContacts = ({ currentPage, aifetchedData, handleSelection, selectedContacts, dataPerPage, handleCheckboxChange, selectedEmails, setSelectedEmails, selectedPhones, setSelectedPhones }) => {
  const checkCompanyLevelSelection = (item) => {
    const parentEmails = item.email_data.map((data) => data.contact_value + item.company_id);
    const selectedEmailsSet = new Set(selectedEmails);
    const parentPhones = item.phone_data.map((data) => data.contact_value + item.company_id);
    const selectedPhonesSet = new Set(selectedPhones);
    return parentEmails.every((email) => selectedEmailsSet.has(email)) && parentPhones.every((phone) => selectedPhonesSet.has(phone));
  };
  return (
    <div>
      <Accordion defaultActiveKey={aifetchedData[0].company_id} className={`${styles.company_accordion}`}>
        {aifetchedData.length > 0 &&
          aifetchedData.slice((currentPage - 1) * dataPerPage, currentPage * dataPerPage).map((item) => {
            return (
              <div className="pb-1" key={item.company_id}>
                <div className={`${styles.accordion_toggle}`}>
                  <Accordion.Toggle eventKey={item.company_id} className={`${styles.company_accordion}`}>
                    <ChevronDown size={16} color="#1a1722" className="ml-auto mr-2 chevron-toggle-hide" />
                  </Accordion.Toggle>
                  <input
                    type="checkbox"
                    className="form-check-input position-relative mr-2 ml-0"
                    onChange={(e) => {
                      handleSelection(item, e.target.checked);
                    }}
                    checked={checkCompanyLevelSelection(item)}
                  />
                  <span className="text-capitalize">{item.company_name}</span>
                </div>
                <Accordion.Collapse eventKey={item.company_id}>
                  <div className={`d-flex w-100 py-2 ${styles.scan_contact_container}`}>
                    {item.phone_data.length > 0 && (
                      <div className={`${styles.section_container} w-50 pt-3 pt-1`}>
                        <SectionTable keyName="phone" data={item.phone_data} selectedContacts={selectedContacts} companyId={item.company_id} handleCheckboxChange={handleCheckboxChange} selectedEmails={selectedEmails} setSelectedEmails={setSelectedEmails} selectedPhones={selectedPhones} setSelectedPhones={setSelectedPhones} />
                      </div>
                    )}
                    {item.email_data.length > 0 && (
                      <div className={`${styles.section_container} w-50 pt-3`}>
                        <SectionTable keyName="email" data={item.email_data} selectedContacts={selectedContacts} companyId={item.company_id} handleCheckboxChange={handleCheckboxChange} selectedEmails={selectedEmails} setSelectedEmails={setSelectedEmails} selectedPhones={selectedPhones} setSelectedPhones={setSelectedPhones} />
                      </div>
                    )}
                  </div>
                </Accordion.Collapse>
              </div>
            );
          })}
      </Accordion>
    </div>
  );
};

export default AIFetchedContacts;
